/*
// 入力された文字数を表示する
<div class="js-textCount">
    <input name="" type="text" value="" placeholder="" data-text-count-max="30">
    <span class="js-textCount-output">-</span>
</div>
*/
/**
 * 文字数をカウントして返す
 * @param {string} text 文字列
 * @returns
 */
function textCount(text) {
  // const segmenter = new Intl.Segmenter('ja', { granularity: 'grapheme' })
  // return [...segmenter.segment(text)].length
  return [...text].length
}
// 入力時の実行
window.addEventListener('input', function (e) {
  const item = e.target.closest('.js-textCount')
  if (!item) {
    return
  }
  applyTextCount(item)
})
// アクセス時の実行
const textCountList = document.getElementsByClassName('js-textCount')
for (const item of textCountList) {
  applyTextCount(item)
}
// 反映処理
function applyTextCount(item) {
  const input = item.querySelector('[data-text-count-max]')
  const targetList = item.querySelectorAll('.js-textCount-output')
  if (input) {
    const max = parseInt(input.dataset.textCountMax, 10)
    let min = 0
    if (input.dataset.textCountMin) {
      min = parseInt(input.dataset.textCountMin, 10)
    }
    const count = textCount(input.value)

    let text = count
    if (count > max || (min !== 0 && count < min)) {
      text = '<span style="color:red">' + text + '</span>'
    }

    for (const target of targetList) {
      if (count === 0) {
        // 0なら非表示
        target.style.display = 'none'
      } else {
        target.style.display = ''
        target.innerHTML = text + '/' + max
      }
    }
  }
}

window.textCount = function () {
  const itemList = document.querySelectorAll('.js-textCount')
  for (const item of itemList) {
    applyTextCount(item)
  }
}
